module.exports = __webpack_public_path__ + "img/featuredartist (4).438a1981.jpg";